const cardOrListThemeValues = {
  breakpoints: {
    values: {
      xs: 100,
      sm: 800,
      md: 1350,
      lg: 1880,
      xl: 2410,
    },
  },
};

export default cardOrListThemeValues;
